"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.$article = exports.articleToLines = void 0;
const line_1 = require("../../../node/cst/line");
const std_1 = require("../../../law/std");
const std = __importStar(require("../../../law/std"));
const columnsOrSentences_1 = require("./columnsOrSentences");
const toCSTSettings_1 = __importDefault(require("../toCSTSettings"));
const util_1 = require("../../../util");
const inline_1 = require("../../../node/cst/inline");
const util_2 = require("../util");
const factory_1 = __importDefault(require("../factory"));
const virtualLine_1 = require("../virtualLine");
const util_3 = require("../util");
const _paragraphItem_1 = __importStar(require("./$paragraphItem"));
const _supplNote_1 = __importStar(require("./$supplNote"));
const el_1 = require("../../../node/el");
const num_1 = require("../../../law/num");
const _sentenceChildren_1 = __importStar(require("../../cst/rules/$sentenceChildren"));
const env_1 = require("../../cst/env");
/**
 * The renderer for {@link std.Article}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$article.spec.ts) for examples.
 */
const articleToLines = (el, indentTexts) => {
    const lines = [];
    const ArticleCaption = [];
    const ArticleTitle = [];
    const Paragraphs = [];
    const SupplNotes = [];
    for (const child of el.children) {
        if (child.tag === "ArticleCaption") {
            ArticleCaption.push(...child.children);
        }
        else if (child.tag === "ArticleTitle") {
            ArticleTitle.push(...child.children);
        }
        else if (child.tag === "Paragraph") {
            Paragraphs.push(child);
        }
        else if (child.tag === "SupplNote") {
            SupplNotes.push(child);
        }
        else {
            (0, util_1.assertNever)(child);
        }
    }
    if (ArticleCaption.length > 0) {
        const newIndentTexts = [...indentTexts, toCSTSettings_1.default.INDENT];
        const captionString = (0, _sentenceChildren_1.sentenceChildrenToString)(ArticleCaption);
        const result = _sentenceChildren_1.default.match(0, captionString, (0, env_1.initialEnv)({}));
        if (!result.ok) {
            const message = `addControls: Error: ${captionString}`;
            throw new Error(message);
        }
        const line = new line_1.OtherLine({
            range: null,
            indentTexts: newIndentTexts,
            controls: [],
            sentencesArray: [
                new inline_1.Sentences("", null, [], [(0, std_1.newStdEL)("Sentence", {}, result.value.value)])
            ],
            lineEndText: toCSTSettings_1.default.EOL,
        });
        if (!(0, util_2.isSingleParentheses)(line)) {
            line.controls.push(new inline_1.Control(util_2.captionControl, null, "", null));
        }
        lines.push(line);
    }
    if ((Paragraphs.length > 0) &&
        // Paragraphs[0] has ParagraphNum
        ((Paragraphs[0].children.find(std.isParagraphNum)?.text() ?? "") !== "")) {
        // Add an empty Paragraph at the beginning
        Paragraphs.unshift((0, std_1.newStdEL)("Paragraph"));
    }
    for (let i = 0; i < Paragraphs.length; i++) {
        const Paragraph = Paragraphs[i];
        const paragraphLines = (0, _paragraphItem_1.paragraphItemToLines)(Paragraph, indentTexts, {
            firstArticleParagraphArticleTitle: (i === 0 && ArticleTitle) ? ArticleTitle : undefined,
            secondaryArticleParagraph: i >= 1,
            defaultTag: "Paragraph",
        });
        lines.push(...paragraphLines);
    }
    for (const SupplNote of SupplNotes) {
        lines.push(...(0, _supplNote_1.supplNoteToLines)(SupplNote, indentTexts));
    }
    return lines;
};
exports.articleToLines = articleToLines;
/**
 * The parser rule for {@link std.Article}. Please see the source code for the detailed syntax, and the [test code](https://github.com/yamachig/Lawtext/blob/main/core/src/parser/std/rules/$article.spec.ts) for examples.
 */
exports.$article = factory_1.default
    .withName("article")
    .sequence(s => s
    .and(r => r
    .zeroOrOne(r => r
    .sequence(s => s
    .and(r => r
    .oneMatch(({ item }) => {
    if (item.type === virtualLine_1.VirtualOnlyLineType.CAP) {
        return item;
    }
    else {
        return null;
    }
}))
    .andOmit(r => r.zeroOrMore(() => util_3.$blankLine)))), "captionLine")
    .and(r => r
    .oneMatch(({ item }) => {
    if (item.type === line_1.LineType.ART) {
        return item;
    }
    else {
        return null;
    }
}), "firstParagraphItemLine")
    .andOmit(r => r.zeroOrMore(() => util_3.$blankLine))
    .and(r => r
    .zeroOrOne(() => _paragraphItem_1.$autoParagraphItemChildrenOuter), "firstAutoParagraphChildren")
    .andOmit(r => r.zeroOrMore(() => util_3.$blankLine))
    .and(r => r
    .zeroOrMore(r => r
    .sequence(s => s
    .andOmit(r => r.zeroOrMore(() => util_3.$blankLine))
    .and(() => (0, _paragraphItem_1.default)("Paragraph")))), "otherParagraphs")
    .andOmit(r => r.zeroOrMore(() => util_3.$blankLine))
    .and(r => r
    .zeroOrMore(() => _supplNote_1.default), "supplNotes")
    .action(({ captionLine, firstParagraphItemLine, firstAutoParagraphChildren, otherParagraphs, supplNotes }) => {
    const article = (0, std_1.newStdEL)("Article");
    const errors = [
        ...(firstAutoParagraphChildren?.errors ?? []),
        ...otherParagraphs.map(p => p.errors).flat(),
        ...supplNotes.map(n => n.errors).flat(),
    ];
    if (captionLine) {
        article.children.push((0, std_1.newStdEL)("ArticleCaption", {}, captionLine.line.sentencesArray
            .map(sa => sa.sentences.map(s => s.children))
            .flat(2), captionLine.line.sentencesArrayRange));
    }
    if (firstParagraphItemLine.line.title) {
        article.children.push((0, std_1.newStdEL)("ArticleTitle", {}, [firstParagraphItemLine.line.title], firstParagraphItemLine.line.titleRange));
        const num = (0, num_1.parseNamedNum)(firstParagraphItemLine.line.title);
        if (num)
            article.attr.Num = num;
    }
    if ((firstParagraphItemLine.line.sentencesArray.length > 0) || firstAutoParagraphChildren) {
        const firstParagraph = (0, std_1.newStdEL)("Paragraph");
        // firstParagraph.attr.OldStyle = "false";
        const sentencesArrayRange = firstParagraphItemLine.line.sentencesArrayRange;
        firstParagraph.children.push((0, std_1.newStdEL)("ParagraphNum", {}, [], sentencesArrayRange ? [sentencesArrayRange[0], sentencesArrayRange[0]] : null));
        firstParagraph.children.push((0, std_1.newStdEL)("ParagraphSentence", {}, (0, columnsOrSentences_1.sentencesArrayToColumnsOrSentences)(firstParagraphItemLine.line.sentencesArray), sentencesArrayRange));
        if (firstAutoParagraphChildren) {
            firstParagraph.children.push(...firstAutoParagraphChildren.value);
        }
        firstParagraph.range = (0, el_1.rangeOfELs)(firstParagraph.children);
        {
            const paragraph = (0, _paragraphItem_1.paragraphItemFromAuto)("Paragraph", firstParagraph);
            paragraph.attr.Num = "1";
            article.children.push(paragraph);
        }
    }
    article.children.push(...otherParagraphs.map((p, i) => {
        if (std.isParagraph(p.value) && p.value.attr.OldNum === "true") {
            p.value.attr.Num = (i + 2).toString();
        }
        return p.value;
    }));
    article.children.push(...supplNotes.map(n => n.value));
    const pos = captionLine ? captionLine.line.indentsEndPos : firstParagraphItemLine.line.indentsEndPos;
    const range = (0, el_1.rangeOfELs)(article.children) ?? (pos !== null ? [pos, pos] : null);
    if (range && pos !== null) {
        range[0] = pos;
    }
    article.range = range;
    return {
        value: article,
        errors,
    };
}));
exports.default = exports.$article;
//# sourceMappingURL=$article.js.map